/**
 * @generated SignedSource<<fa3cf54abe9d9a388decbc47d082d064>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoCarousel_interiorPhotos$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedInteriorsPhotoRelatedSearchLinks_interiorPhotos">;
  readonly " $fragmentType": "SbRespInteriorsPhotoCarousel_interiorPhotos";
};
export type SbRespInteriorsPhotoCarousel_interiorPhotos$key = {
  readonly " $data"?: SbRespInteriorsPhotoCarousel_interiorPhotos$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespInteriorsPhotoCarousel_interiorPhotos">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsPhotoCarousel_interiorPhotos",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedInteriorsPhotoRelatedSearchLinks_interiorPhotos"
    }
  ],
  "type": "SearchBrowseInteriorPhotosModule",
  "abstractKey": null
};

(node as any).hash = "dc0cb4304974ac08f47b5717f4be3b2c";

export default node;
